import { h, Component } from "preact";
import $ from "jquery";
import GlobState from 'globstate'
import Globals from '../globals.js'
import $ti from '../ti.js'
import { route } from 'preact-router';

import * as _ from "../components/index.js";

class favsTest extends Component {
  constructor(props) {
    super(props);

    let templates = Globals.Templates();
    let favs = this.getFavs();
    let questions = Object.keys(favs).map((fav) => {
      return this.findQuestionById(templates, fav)
    })

    let answers = this.getAnswers();
    let usedExp = this.getExp();

    this.state = {
      questionsTotal: questions ? Object.keys(questions).length : 0,
      templates: templates,
      questions: questions ? questions : {},
      answers: answers,
      usedExp: usedExp,
      favs: favs,
      activeQuestion: 0,
      lang: props.app.lang,
      // templateId: templateId,
      scrollLeftPosition: 0
    };

    this.setState({
      activeQuestion: this.findFirstQuestion()
    })
  }

  findQuestionById(templates, id) {
    let rt = [];
    let finded = false;
    for (let i = 0; i < Object.keys(templates).length; i++) {
      let template = templates[i];
      for (var m = 0; m < template.questions.length; m++) {
        let question = template.questions[m];
        if (question.id == id) {
          rt = question;
          finded = true;
          break;
        }
      }
      if (finded) {
        break;
      }
    }
    return rt;
  }

  getAnswers = () => {
    let answers = {};
    let templateIds = {};

    let templates = Globals.Templates();
    if (templates) {
      let i = 0;
      Object.keys(templates).map(template => {
        templateIds[(i + 1)] = 1;
        i++;
      });
    }

    Object.keys(templateIds).map((id) => {
      let data = localStorage.getItem('favs_answers_' + id);
      if (data) {
        let tmp = JSON.parse(data) ? JSON.parse(data) : {};
        Object.keys(tmp).map((fav) => {
          tmp[fav] = parseInt(tmp[fav]);
        })
        answers = { ...answers, ...tmp }
      }
    })
    return answers;
  }


  getExp = () => {
    let exp = {};
    let templateIds = {};

    let templates = Globals.Templates();
    if (templates) {
      let i = 0;
      Object.keys(templates).map(template => {
        templateIds[i] = 1;
        i++;
      });
    }

    Object.keys(templateIds).map((id) => {
      let data = localStorage.getItem('favs_exp_' + id);
      if (data) {
        let tmp = JSON.parse(data) ? JSON.parse(data) : {};
        Object.keys(tmp).map((fav) => {
          tmp[fav] = parseInt(tmp[fav]);
        })
        exp = { ...exp, ...tmp }
      }
    })
    return exp;
  }

  getFavs = () => {
    let favs = {};
    let templateIds = {};

    let templates = Globals.Templates();
    if (templates) {
      let i = 0;
      Object.keys(templates).map(template => {
        templateIds[i] = 1;
        i++;
      });
    }

    Object.keys(templateIds).map((id) => {
      let data = localStorage.getItem('favs_' + id);
      if (data) {
        let tmp = JSON.parse(data) ? JSON.parse(data) : {};
        Object.keys(tmp).map((fav) => {
          tmp[fav] = parseInt(id);
        })
        favs = { ...favs, ...tmp }
      }
    })
    return favs;
  }

  findFirstQuestion() {
    let questions = this.state.questions;
    let questionNum = 0;
    let finded = false;

    {
      Object.keys(questions).map((tmp) => {
        if (!finded) {
          let question = questions[tmp];
          if (this.state.answers && !this.state.answers[question.id]) {
            if (this.state.usedExp && !this.state.usedExp[question.id]) {
              questionNum = tmp;
              finded = true;
            }
          }
        }
      })
    }
    return questionNum;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

  }

  componentDidMount() {

  }

  hideExp = (e) => {
    $('.questionExp').addClass('d-none');
  }

  showExp = (e) => {
    $('.questionExp').removeClass('d-none');

    let t = $(e.target).closest('.idea');
    let templateId = parseInt(t.attr('data-template'));
    let questionId = parseInt(t.attr('rel'));
    let expData = localStorage.getItem('favs_exp_' + templateId) ? localStorage.getItem('favs_exp_' + templateId) : '{}';
    let exp = JSON.parse(expData);

    if (!exp) {
      exp = {}
    }
    exp[questionId] = 1;
    localStorage.setItem('favs_exp_' + templateId, JSON.stringify(exp));

    this.setState({
      usedExp: this.getExp()
    })

  }

  setActiveQuestion = (e) => {
    let rel = parseInt($(e.target).attr('rel'));
    this.setState({
      activeQuestion: rel
    })
    this.centerActiveItem(rel);
  }

  setAnswer = (e) => {

    let t = $(e.target);
    let questionId = parseInt(t.attr('rel'));
    let answerId = parseInt(t.val());
    let templateId = parseInt(t.attr('data-template'));

    let answersData = localStorage.getItem('favs_answers_' + templateId) ? localStorage.getItem('favs_answers_' + templateId) : '{}';
    let answers = JSON.parse(answersData ? answersData : '{}');

    let expData = localStorage.getItem('favs_exp_' + templateId) ? localStorage.getItem('favs_exp_' + templateId) : '{}';
    let exp = JSON.parse(expData);


    if (!answers) {
      answers = {}
    }

    let isAnswered = answers[questionId] ? true : false;

    if (isAnswered) {
      e.preventDefault();
      return false;
    }

    answers[questionId] = answerId;

    if (exp) {
      if (exp[questionId]) {
        delete exp[questionId];
        this.setState({
          usedExp: this.getExp()
        })
      }
    }

    localStorage.setItem('favs_exp_' + templateId, JSON.stringify(exp));

    let isCorrect = false;
    let idx = this.state.questions.findIndex(x => x.id == questionId);
    let idxA = this.state.questions[idx].answers.findIndex(x => x.id == answerId);

    if (this.state.questions[idx].answers[idxA].isCorrect) {
      isCorrect = true;
    }

    localStorage.setItem('favs_answers_' + templateId, JSON.stringify(answers));

    this.setState({
      answers: this.getAnswers(),
    })

    if (isCorrect && this.state.activeQuestion != (Object.keys(this.state.questions).length - 1)) {
      // setTimeout(this.nextQuestion, 2000);
      this.nextQuestion();
    }

  }

  nextQuestion = () => {
    let nextQuestion = parseInt(this.state.activeQuestion) + 1;
    if (nextQuestion > (Object.keys(this.state.questions).length - 1)) {
      nextQuestion = (Object.keys(this.state.questions).length - 1);
    }
    if (this.state.activeQuestion == (Object.keys(this.state.questions).length - 1)) {
      nextQuestion = this.findFirstQuestion();
    }
    this.setState({
      activeQuestion: nextQuestion
    })
    this.centerActiveItem(nextQuestion);
    window.scrollTo({ top: 0 });
  }

  centerActiveItem = (act) => {
    if (typeof act == 'undefined') {
      act = this.state.activeQuestion;
    }
    let scrollPosition
    if (act > (Object.keys(this.state.questions).length / 2)) {
      scrollPosition = (act + 2) * 44
    } else {
      scrollPosition = (act - 2) * 44
    }

    const scrollContainer = this.scrollRef;
    if (scrollContainer) {
      scrollContainer.scrollTo(scrollPosition, 0);
    }
  }

  showErrorModal = () => {

  }

  complete = () => {

  }

  restart = () => {

    let favs = this.getFavs();
    Object.keys(favs).map((fav) => {
      let question = this.findQuestionById(this.state.templates, fav);
      let templateId = question.templateId;
      localStorage.removeItem('favs_answers_' + templateId);
      localStorage.removeItem('favs_exp_' + templateId);
    })
    // route(`/fav/test/`);
    window.location.reload();
  }

  addFav = (e) => {
    let t = $(e.target);
    let templateId = parseInt(t.attr('data-template'));
    let data = JSON.parse(localStorage.getItem('favs_' + templateId))
    let questionId = parseInt(t.attr('rel'));

    if (!data) {
      data = {}
    }
    data[questionId] = 1

    localStorage.setItem('favs_' + templateId, JSON.stringify(data));
    this.setState({
      favs: this.getFavs()
    })

    $('#add_favorite_item').parent().find('.btn-secondary').click();
  }

  delFav = (e) => {
    let t = $(e.target);
    let templateId = parseInt(t.attr('data-template'));
    let data = JSON.parse(localStorage.getItem('favs_' + templateId))
    let questionId = parseInt(t.attr('rel'));
    if (data) {
      if (data[questionId]) {
        delete data[questionId];
        localStorage.setItem('favs_' + templateId, JSON.stringify(data));
        this.setState({
          favs: this.getFavs()
        })
      }
    }
    $('#del_favorite_item').parent().find('.btn-secondary').click();
  }

  render() {
    let lang = this.state.lang
    let template = this.state.template;
    let questions = this.state.questions ? this.state.questions : {};
    let favs = this.state.favs ? this.state.favs : {};
    let questionsTotal = this.state.questionsTotal;

    let activeQuestion = this.state.activeQuestion;

    let data = this.state.questions ? this.state.questions[activeQuestion] : {};
    let image = data ? data.image : null;
    let answers = data ? data.answers : null;

    let qClass = '';
    let correctAnswer = '';
    let displayExp = 'd-none';
    let displayExpIcon = '';
    let ansLength = this.state.answers ? Object.keys(this.state.answers).length : 0
    let exp = this.state.usedExp ? this.state.usedExp : {}
    let expLength = this.state.usedExp ? Object.keys(this.state.usedExp).length : 0

    let displayNextQuestion = (ansLength + expLength != questionsTotal ? '' : 'd-none');
    let displayComplete = (ansLength + expLength == questionsTotal ? '' : 'd-none');

    let isFav = favs[data.id] ? true : false;

    let counters = {
      correct: 0,
      exp: 0,
    }
    return (
      <>

        <section class="header">

          <div class="header_menu">
            <div class="d-flex align-items-center">
              <a href={ansLength > 0 ? "#" : '/fav/'} class="mx-2" type="button" data-bs-toggle={ansLength > 0 ? "modal" : false} data-bs-target="#back"><i class="demo-icon icon-angle-left"></i></a>
              <span class="ms-2">Избранные вопросы </span>
            </div>
            <div class="d-flex align-items-center">
              {/* <span class="time"><i class="demo-icon icon-clock-1 me-1"></i>15:00</span> */}
              {!isFav ?
                <a href="#" class="mx-2" type="button" data-bs-toggle="modal" data-bs-target="#add_favorite_item">
                  <i class="demo-icon icon-heart-empty-1 red_icon"></i>
                </a>
                :
                <a href="#" class="mx-2" data-bs-toggle="modal" data-bs-target="#del_favorite_item">
                  <i class="demo-icon icon-heart-1 red_icon"></i>
                </a>
              }

            </div>
          </div>

          <div class="options" ref={(ref) => (this.scrollRef = ref)}>
            {Object.keys(questions).map((tmp, index) => {
              { qClass = '' }

              {
                if (exp[questions[tmp].id]) {
                  qClass = 'option_orange';
                } else {
                  if (this.state.answers && this.state.answers[questions[tmp].id]) {
                    if (questions[tmp].correctId == this.state.answers[questions[tmp].id]) {
                      counters.correct++;
                      qClass = 'option_green';
                    } else {
                      qClass = 'option_red';
                    }
                  }
                }

                if (activeQuestion == tmp) {
                  qClass += ' option_active';
                }
              }

              return <a href="javascript:void(0)" ref={(ref) => {
                if (activeQuestion == tmp) {
                  this.activeRef = ref;
                }
              }} onClick={this.setActiveQuestion} rel={tmp} class={`option ${qClass}`}>{((parseInt(this.state.templates[(questions[tmp].templateId - 1)].title.replace('# ', '')) - 1) * 20) + questions[tmp].ord}</a>
            })}
          </div>

        </section>

        <section class="menu menu_test">

          <div class="quest">
            {(image ? <img src={image} alt="" class="quest_img" /> : null)}
            <span class="font_bold">Вопрос:</span>
            <span class="">{data.question[lang]}</span>
          </div>

          <div class="my-2">
            {Object.keys(answers).map((tmp) => {
              var isChecked = false;
              var isCorrect = false;
              var className = 'false';

              if (answers[tmp]['isCorrect']) {
                correctAnswer = answers[tmp][lang]
                exp = answers[tmp]['exp'][lang]
                isCorrect = true;
                className = 'true';
              } else {
                // className = 'false';
              }

              if (this.state.answers && this.state.answers[data.id]) {

                if (isCorrect && this.state.answers[data.id] != answers[tmp]['id']) {
                  className = 'bg-success';
                } else {
                  displayExp = '';
                  displayExpIcon = 'd-none';
                }
              }

              if (this.state.answers && this.state.answers[data.id] == answers[tmp]['id']) {
                isChecked = true;
              } else {
                if (isCorrect) {
                  if (this.state.usedExp && this.state.usedExp[data.id]) {
                    // isChecked = true;
                    className = 'bg-success';
                    displayExp = '';
                    displayExpIcon = 'd-none';
                  }
                }
              }

              return <span>
                <input type="radio" class={className} id={`answer_${answers[tmp]['id']}`} rel={data.id} name={`answer`} value={answers[tmp]['id']} data-isCorrect={answers[tmp]['isCorrect']} onClick={this.setAnswer} data-template={data.templateId} checked={isChecked} />
                <label for={`answer_${answers[tmp]['id']}`}>{answers[tmp][lang]}</label>
              </span>
            })}
          </div>

          <div class={`d-flex flex-column questionExp ${displayExp}`}>
            <span class="font_bold">Правильный ответ:</span>
            <span class="mt-1">{correctAnswer}</span>

            <a class={`btn btn-info mt-3 ${displayNextQuestion}`} href="javascript:void(0)" onClick={this.nextQuestion} role="button">Следующий вопрос</a>
            <a class={`btn btn-info mt-3 ${displayComplete}`} href="javascript:void(0)" onClick={this.complete} data-bs-toggle="modal" data-bs-target="#finish">Готово</a>

            <span class="font_bold mt-3">Комментарий:</span>
            <span class="mt-1" dangerouslySetInnerHTML={{
              __html: exp
            }}></span>

            <a class="btn btn-light mt-3" onClick={this.showErrorModal} href="javascript:void(0)" role="button">Сообщить об ошибке</a>
          </div>


          <a href="javascript:void(0)" onClick={this.showExp} rel={data.id} data-template={data.templateId} class={`idea ${displayExpIcon}`}><i class="demo-icon icon-lightbulb-1"></i></a>
        </section>

        <div class="modal fade" id="add_favorite_item" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                  <span class="mb-3 font20">Добавить в избранное?</span>
                  <div>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Отмена</button>
                    <button type="button" class="btn btn-success mx-3" rel={data.id} data-template={data.templateId} onClick={this.addFav}>Добавить</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="del_favorite_item" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                  <span class="mb-3 font20">Удалить вопрос из избранного?</span>
                  <div>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Отмена</button>
                    <button type="button" class="btn btn-danger mx-3" rel={data.id} data-template={data.templateId} onClick={this.delFav}>Удалить</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="back" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                  <span class="mb-3 font20">Хотите выйти?</span>
                  <div>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Отмена</button>
                    <a href="/fav/" class="btn btn-danger ms-3" data-bs-dismiss="modal">Выход</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="finish" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                  <span class="mb-3 font20">Результат:</span>

                  <span class="mb-1">Правильный <span class="text-success">{counters.correct}</span> \ {questionsTotal}</span>
                  <span class="mb-1">Неправильный <span class="text-danger">{questionsTotal - (counters.correct + expLength)}</span> \ {questionsTotal}</span>
                  {expLength > 0 ? <div class="mb-1">Подсказки <span class="text-warning">{expLength}</span></div> : null}
                  <div class="mt-3">
                    <button type="button" class="btn btn-primary" onClick={this.restart}>Начать сначала</button>
                    <button type="button" class="btn btn-success mx-2" data-bs-dismiss="modal">ОК</button>
                    <a href="/fav/" type="button" class="btn btn-info mx-2" data-bs-dismiss="modal">Назад</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </>
    );
  }
}

export default GlobState.connect(favsTest, Globals)